// extracted by mini-css-extract-plugin
export default {"centeredTextBlock":"sR3g2co2DKvjTg6ym09v","largeIcon":"QZrS4zLqv3IrvuICC_HU"};